import { createAsyncThunk } from "@reduxjs/toolkit";
import doFetch from "../../infrastructure/doFetch";
import { getQueryParams } from "../../helpers";
import { SPINNER_NAMES } from "../../components/organisms/Spinner";
import { EMPTY_STRING } from "../../constants";

const { FETCH_ORGANIZATIONS, FETCH_ORGANIZATIONS_USERS } = SPINNER_NAMES;

export const fetchOrganizations = createAsyncThunk(
  "fetch-organizations",
  async (filters, args, { useCache, showSpinner } = {}) => {
    const queryParams = getQueryParams(filters) || EMPTY_STRING;
    return doFetch({
      url: `organizations?${queryParams}`,
      method: "GET",
      useCache,
      showSpinner,
      spinner: FETCH_ORGANIZATIONS,
      errorMessage: "Unable to fetch organizations. Please try again later.",
      successMessage: "Successfully fetched Organizations.",
      ...args,
    });
  }
);

export const fetchOrganizationUsersById = createAsyncThunk(
  "fetch-organization-users-by-id",
  async ({ id, filters }, args, { useCache, showSpinner } = {}) => {
    const queryParams = getQueryParams(filters) || EMPTY_STRING;
    return doFetch({
      url: `organizations/${id}?${queryParams}`,
      method: "GET",
      useCache,
      showSpinner,
      spinner: FETCH_ORGANIZATIONS_USERS,
      errorMessage: "Unable to fetch the user by id. Please try again later.",
      successMessage: "Successfully fetched the users by id.",
      ...args,
    });
  }
);

export const deleteOrganization = createAsyncThunk(
  "delete-organization",
  async (id, args, { useCache } = {}) =>
    doFetch({
      url: `organizations/${id}`,
      method: "DELETE",
      useCache,
      errorMessage: "Unable to delete organization. Please try again later.",
      successMessage: "Successfully deleted organization.",
      ...args,
    })
);

export const updateOrganization = createAsyncThunk(
  "update-organization",
  async ({ id, data, useCache } = {}, args) =>
    doFetch({
      url: `organizations/${id}`,
      method: "PATCH",
      config: {
        body: JSON.stringify(data),
      },
      useCache,

      errorMessage:
        "Unable to update the organization. Please try again later.",
      successMessage: "Successfully updated the organization.",
      ...args,
    })
);

export const createOrganization = createAsyncThunk(
  "create-organization",
  async (data, args, { useCache, showSpinner } = {}) =>
    doFetch({
      url: "organizations",
      method: "POST",
      config: {
        body: JSON.stringify(data),
      },
      useCache,
      showSpinner,
      errorMessage:
        "Unable to create the organization. Please try again later.",
      successMessage: "Successfully created the organization.",
      ...args,
    })
);
